import * as angular from "angular";

export class ContactMethodService {
    private readonly apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/contactmethod";
    }

    all(): Promise<object> {
        return this.$http.get(this.apiRoot + "/all/");
    }
}

angular
    .module("vcServices")
    .service("ContactMethodService", ContactMethodService);
